// extracted by mini-css-extract-plugin
export default {"discussionsList":"ListContainer-module__discussionsList--363a"};